import UcRentalFormFixedAssets from './UcRentalFormFixedAssets.yaml?component';

export { UcRentalFormFixedAssets };
